export const register = () => {
  throw new Error('Push notifications not available on web')
}

export const requestPermission = () => {
  console.log('Skipping requesting notifications permission')
}
